import React from "react";
import "./FleetCoreVehicleRegistrationBaseline.css";

import fleetcoreVehicleRegistrationBaselinePhotoJpg from "../../images/fleetcore-vehicle-registration-baseline-depot-capture.jpg";
import fleetcoreVehicleRegistrationBaselinePhotoWebp from "../../images/fleetcore-vehicle-registration-baseline-depot-capture.webp";
import fleetcoreVehicleRegistrationBaselineInterface from "../../images/fleetcore-vehicle-registration-baseline-interface.svg";

export default function FleetCoreVehicleRegistrationBaseline() {
  return (
    <section className="fleetcore-vehicle-registration-baseline" id="fleetcore-vehicles" aria-labelledby="fleetcore-vehicle-registration-baseline-title">
      <div className="fleetcore-vehicle-registration-baseline__inner">
        <div className="fleetcore-vehicle-registration-baseline__copy">
          <p className="fleetcore-vehicle-registration-baseline__eyebrow">ESTABLISH THE ASSET</p>
          <h2 id="fleetcore-vehicle-registration-baseline-title">Every vehicle starts with a verified baseline.</h2>
          <p className="fleetcore-vehicle-registration-baseline__body">Registration evidence, guided photos and the opening odometer become one reviewable starting point before the first active shift.</p>
          <div className="fleetcore-vehicle-registration-baseline__tags" aria-label="Vehicle baseline evidence">
            <span>Identity structured</span><span>Condition captured</span>
          </div>
          <p className="fleetcore-vehicle-registration-baseline__principle">One vehicle. One evidence-backed starting point.</p>
        </div>
        <div className="fleetcore-vehicle-registration-baseline__visual">
          <picture><source srcSet={fleetcoreVehicleRegistrationBaselinePhotoWebp} type="image/webp" /><img src={fleetcoreVehicleRegistrationBaselinePhotoJpg} alt="Fleet supervisor capturing vehicle registration evidence at a commercial depot" /></picture>
          <img className="fleetcore-vehicle-registration-baseline__interface" src={fleetcoreVehicleRegistrationBaselineInterface} alt="FleetCore vehicle baseline interface showing structured registration, photographs, odometer and condition evidence" />
        </div>
      </div>
    </section>
  );
}